/**
 * Compact player-season summary used by the class comparison view.
 * Produced by the pipeline script `scripts/build-class-summary.js`.
 *
 * players[i] = [name, classYear, round, pick]
 * rows[j]    = [playerIndex, season, collegeId, pos, weeksWithStats, ytdPoints,
 *               pass, rush, rec, def, kick, punt, ret, offFumbles]
 */

export type ClassSummaryPlayer = [
  name: string,
  classYear: number | null,
  round: number | null,
  pick: number | null,
];

export type ClassSummaryRow = [
  playerIndex: number,
  season: number,
  collegeId: string,
  pos: string | null,
  weeksWithStats: number,
  ytdPoints: number,
  pass: number,
  rush: number,
  rec: number,
  def: number,
  kick: number,
  punt: number,
  ret: number,
  offFumbles: number,
];

export const ROW = {
  playerIndex: 0,
  season: 1,
  collegeId: 2,
  pos: 3,
  weeksWithStats: 4,
  ytdPoints: 5,
  pass: 6,
  rush: 7,
  rec: 8,
  def: 9,
  kick: 10,
  punt: 11,
  ret: 12,
  offFumbles: 13,
} as const;

export const PLAYER = {
  name: 0,
  classYear: 1,
  round: 2,
  pick: 3,
} as const;

export interface ClassSummaryFile {
  fromYear: number;
  toYear: number;
  ytdWeek: number;
  currentSeasonIncomplete: boolean;
  players: ClassSummaryPlayer[];
  rows: ClassSummaryRow[];
}

export const rowFantasyPoints = (row: ClassSummaryRow): number =>
  row[ROW.pass] +
  row[ROW.rush] +
  row[ROW.rec] +
  row[ROW.def] +
  row[ROW.kick] +
  row[ROW.punt] +
  row[ROW.ret] +
  row[ROW.offFumbles];
